import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-alert-snackbar',
    templateUrl: './alert-snackbar.html',
    styleUrl: './alert-snackbar.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButtonModule, MatIconModule, MatSnackBarModule],
})
export class AlertSnackbar {
    readonly snackBarRef: MatSnackBarRef<AlertSnackbar> = inject(MatSnackBarRef<AlertSnackbar>);
    readonly data: { message: string } = inject<{ message: string }>(MAT_SNACK_BAR_DATA);
}
